import React from 'react';

export default function EncabezadoSST({ datos, setDatos, listaSedes = [] }) {
  const handleChange = (e) => {
    setDatos({ ...datos, [e.target.name]: e.target.value });
  };

  return (
    <div className="bg-white/40 backdrop-blur-xl p-4 sm:p-6 rounded-[20px] shadow-sm border border-white/60 mb-5 relative overflow-hidden">
      
      {/* CABECERA CON IDENTIFICADOR DE MARCA */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4 pb-3 border-b border-white/40">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white/60 rounded-xl flex items-center justify-center text-xl border border-white shrink-0 shadow-sm">
            📋
          </div>
          <div>
            <h2 className="text-sm font-black text-slate-800 uppercase tracking-tight leading-tight">Datos Generales</h2>
            <p className="text-[10px] text-slate-600 font-medium mt-0.5">Información básica del Punto de Venta a inspeccionar</p>
          </div>
        </div>

        {/* SELECTOR DE MARCA */}
        <div className="flex items-center gap-2 bg-white/60 backdrop-blur-md px-3 py-1.5 rounded-xl border border-white/80 shadow-inner">
          <span className="text-[10px] font-black text-slate-500 uppercase">Unidad:</span>
          <select 
            name="unidadNegocio"
            value={datos.unidadNegocio || "EL GRAN SURTIDOR"} 
            onChange={handleChange}
            className="bg-transparent text-xs font-black text-blue-700 outline-none cursor-pointer"
          >
            <option value="EL GRAN SURTIDOR">El Gran Surtidor</option>
            <option value="LA GRANJA">La Granja</option>
          </select>
        </div>
      </div>

      <div className="flex flex-col sm:grid sm:grid-cols-3 gap-4 items-end">
        {/* PUNTO DE VENTA (PDV) - CON EL MARGEN DE 10px (RECUADRO AMARILLO) */}
        <div className="w-full">
          <label className="block text-[10px] font-black text-slate-700 mb-1.5 uppercase tracking-wide">Punto de Venta (PDV) *</label>
          <select 
            name="pdv"
            value={datos.pdv} 
            onChange={handleChange}
            className="w-full bg-white/70 backdrop-blur-md border border-white focus:bg-white focus:border-blue-400 rounded-lg px-3 text-xs font-bold text-slate-800 outline-none transition-all shadow-sm cursor-pointer h-[40px] my-[10px] box-border"
            style={{ margin: '10px 0px' }}
            required
          >
            <option value="" disabled>-- Seleccione una Sede --</option>
            {listaSedes.map(sede => (
              <option key={sede.id} value={sede.nombre}>
                {sede.nombre} {sede.codigo_bodega ? `(Bodega: ${sede.codigo_bodega})` : ""}
              </option>
            ))}
          </select>
        </div>

        {/* FECHA DE INSPECCIÓN */}
        <div className="w-full">
          <label className="block text-[10px] font-black text-slate-700 mb-1.5 uppercase tracking-wide">Fecha de Inspección *</label>
          <input 
            type="date" 
            name="fecha"
            value={datos.fecha} 
            onChange={handleChange}
            className="w-full bg-white/70 backdrop-blur-md border border-white focus:bg-white focus:border-blue-400 rounded-lg px-3 text-xs font-bold text-slate-800 outline-none transition-all shadow-sm h-[40px] my-[10px] box-border"
            style={{ margin: '10px 0px' }}
            required
          />
        </div>

        {/* INSPECTOR / EVALUADOR */}
        <div className="w-full">
          <label className="block text-[10px] font-black text-slate-700 mb-1.5 uppercase tracking-wide">Inspector / Evaluador *</label>
          <input 
            type="text" 
            name="inspector"
            value={datos.inspector} 
            readOnly
            className="w-full bg-white/30 backdrop-blur-sm border border-white/50 rounded-lg px-3 text-xs font-bold text-slate-600 outline-none cursor-not-allowed shadow-inner h-[40px] my-[10px] box-border"
            style={{ margin: '10px 0px' }}
          />
        </div>
      </div>
    </div>
  );
}